<template>
  <li :class="typeClasses">
    <slot></slot>
  </li>
</template>

<script>
export default {
  name: 'AppExportMenuItem',
  props: {
    typeClasses: { type: String },
  },
};
</script>
